// extracted by mini-css-extract-plugin
export default {"infoText":"ImageCardFooter_infoText__TptJ8","infoTextValue":"ImageCardFooter_infoTextValue__F7A-q"};